import { createSelector } from 'reselect';

export const selectUser = (state) => state.user;

export const getIsUserLoading = (state) => state.user.loading;

export const getPreferredLanguage = createSelector(selectUser, (user) =>
  _.get(user, 'userPreferences.preferredLanguage')
);
